import React from "react";
import { useFormik } from "formik";

import {
  Box,
  ButtonGroup,
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";

import { withRouter } from "react-router";

import ChequeContractStep3FormFields from "./ChequeContractStep3FormFields";
import {
  MUTATION_ADD_CHEQUE_CONTRACT,
  MUTATION_EDIT_CHEQUE_CONTRACT,
} from "../../../../service/ApolloClient/ApolloMutation";
import errorValidationApollo from "../../../../utility/Forms/errorValidationApollo";
import {
  ErrorToast,
  SuccessToast,
} from "../../../../hoc/ToastNotify/ToastNotify";
import { client } from "../../../../service/ApolloClient/ApolloClient";
import { ChequeContractStep3FormValidation } from "./ChequeContractStep3FormValidation";
import checkDateInput from "../../../../utility/CheckDateInput/checkDateInput";
import ChequeContractPrint from "../ChequeContractPrint";
import moment from "moment";

const validationSchema = ChequeContractStep3FormValidation;

const ChequeContractStep3Form = (props) => {
  let valueDefault = {
    first_party_id: "",
    first_party_fullname: "",
    second_party_id: "",
    second_party_fullname: "",
    ratio: props.percent,
    is_signed: false,
    is_closed: false,
    agreement_date: null,
    description: "",
    status: "current",
  };

  if (props.isEdit) {
    valueDefault = {
      ...valueDefault,
      ...props.data,
      is_signed: props.data.is_signed == "1",
      is_closed: props.data.is_closed == "1",
    };
  }

  const formikData = useFormik({
    initialValues: valueDefault,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      // console.log(values.agreement_date, props.originDate);
      // return

      let newValue = values;
      try {
        newValue.agreement_date = checkDateInput(values.agreement_date);
        newValue.origin_date = checkDateInput(moment(props.originDate));
      } catch (e) {
        console.log(e);
      }

      submitHandle(newValue);
    },
  });

  const submitHandle = (values) => {
    let firstCheques = JSON.stringify(props.firstCheques.map((ch) => ch.id));
    let secondCheques = JSON.stringify(props.secondCheques.map((ch) => ch.id));

    values["first_party_id"] = parseInt(values["first_party_id"]);
    values["second_party_id"] = parseInt(values["second_party_id"]);

    setLoading(true);
    client
      .mutate({
        mutation: props.isEdit
          ? MUTATION_EDIT_CHEQUE_CONTRACT
          : MUTATION_ADD_CHEQUE_CONTRACT,
        variables: {
          ...values,
          first_cheques: firstCheques,
          second_cheques: secondCheques,
          ratio: parseFloat(props.percent),
        },
      })
      .then((result) => {
        let cheque = props.isEdit
          ? result.data.editChequeContract
          : result.data.addChequeContract;

        if (cheque === null) {
          ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
          formikData.setErrors(
            errorValidationApollo({ title: "قادر به ثبت نمی باشد" }),
          );
        } else {
          SuccessToast(
            props.isEdit
              ? "با موفقیت ویرایش شد"
              : "خرید دین با موفقیت افزوده شد",
          );
          if (props.isEdit) document.location.reload();
        }
        setLoading(false);

        props.history.push("/cheque-contract/edit/" + cheque.id);
      })
      .catch((reason) => {
        ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
        formikData.setErrors(errorValidationApollo(reason));
        setLoading(false);
      });

    setLoading(true);
  };

  const [loading, setLoading] = React.useState(false);

  // formikData.isSubmitting = false;

  return (
    <Box mt={2}>
      <Card>
        <CardContent>
          <Box ml={2} mb={2} display={"flex"}>
            <Box flexGrow={1} ml={1}>
              <Typography variant={"h5"} align={"left"}>
                {props.isEdit
                  ? "ویرایش قرارداد خرید دین" + props.data.id
                  : " افزودن قرارداد خرید دین"}
              </Typography>
            </Box>
            <Box style={{ textAlign: "left", float: "right" }} display={"flex"}>
              <ButtonGroup style={{ float: "right" }}>
                <ChequeContractPrint
                  setStep={props.setStep}
                  data={valueDefault}
                  firstCheques={props.firstCheques}
                  secondCheques={props.secondCheques}
                  percent={props.percent}
                  originDate={props.originDate}
                  setOriginDate={props.setOriginDate}
                />
              </ButtonGroup>
            </Box>
          </Box>
          <ChequeContractStep3FormFields
            isEdit={props.isEdit}
            loading={loading}
            percent={props.percent}
            originDate={props.originDate}
            {...formikData}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default withRouter(ChequeContractStep3Form);
